module.exports = __webpack_public_path__ + "static/media/laferrari__personalized.d9f35ffa.png";